<div class="row justify-content-center">
    <div class="col-auto">
        <div class="section-header mb-4 d-flex text-center justify-content-center gap-2" style="max-width: 520px;">
            <span class="material-symbols-outlined">tune</span>
            <h1 class="h4">Gestión de <strong class="fw-semibold text-colonial">Parámetros</strong></h1>
        </div>
        <p class="text-muted mx-auto text-center" style="max-width: 520px;">
            Valores de negocio que se aplican de inmediato en la aplicación de clientes, sin necesidad de una nueva
            versión.
        </p>
    </div>
</div>

<div class="row justify-content-center">
    <div class="col-12 col-xl-10">
        <div class="card shadow-sm border-0 overflow-hidden rounded-4">
            <div class="card-header bg-white py-3">
                <h3 class="h5 mb-0 d-flex gap-2 align-items-center">
                    <span class="material-symbols-outlined text-colonial">list</span>
                    <span>Parámetros</span>
                </h3>
            </div>
            <div class="card-body p-0">
                @if (loading) {
                <div class="p-4 text-center text-muted">Cargando...</div>
                } @else if (!parameters.length) {
                <div class="p-4 text-center text-muted">No hay parámetros configurados.</div>
                } @else {
                <ul class="list-group list-group-flush">
                    @for (p of parameters; track p.key) {
                    <li class="list-group-item py-3">
                        <div class="row g-2 align-items-center">
                            <div class="col-12 col-md-7">
                                <div class="fw-semibold">{{ label(p) }}</div>
                                <div class="small text-muted">{{ p.description }}</div>
                                <div class="small text-muted">
                                    Última actualización: {{ p.updatedAt | date: 'dd/MM/yyyy HH:mm' }}
                                    @if (p.updatedBy) { · {{ p.updatedBy }} }
                                </div>
                            </div>
                            <div class="col-8 col-md-3">
                                <input type="text" class="form-control form-control-sm" [(ngModel)]="drafts[p.key]"
                                    [attr.aria-label]="label(p)" (keyup.enter)="save(p)">
                            </div>
                            <div class="col-4 col-md-2 text-end">
                                <button type="button" class="btn btn-sm btn-colonial" (click)="save(p)"
                                    [disabled]="!isDirty(p) || savingKey === p.key">
                                    {{ savingKey === p.key ? 'Guardando...' : 'Guardar' }}
                                </button>
                            </div>
                        </div>
                    </li>
                    }
                </ul>
                }
            </div>
        </div>
    </div>
</div>
